import { ref, watch, computed } from '@vue/composition-api'

import useJwt from "@/auth/jwt/useJwt";
import CISUserService from '@/services/cis-user.service'

import store from "@/store";

export default function cisUsersList() {
  const refUsersTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'account', sortable: false },
    { key: 'name', sortable: false },
    { key: 'username', label: 'email', sortable: false },
    { key: 'role', sortable: false },
    { key: 'actions', sortable: false },
  ]
  const perPage = ref(10)
  const totalUsers = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const statusFilter = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refUsersTable.value ? refUsersTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalUsers.value,
    }
  })

  const reFetchData = () => {
    refUsersTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, statusFilter], () => {
    reFetchData()
  })

  const fetchUsers = (ctx, callback) => {
    var userRole =  useJwt.getUserData().role.id
    var myId = useJwt.getUserData().id
    CISUserService.userList({
      search: searchQuery.value,
      pageNumber: currentPage.value - 1,
      pageSize: perPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      status: statusFilter.value,
      userRole: userRole,
      myId: myId,
    }).then(response => {
      if (response && response.data.success) {
        const { data, total } = response.data
        callback(data)
        totalUsers.value = total
      }
    })
  }

  return {
    fetchUsers,
    tableColumns,
    perPage,
    currentPage,
    totalUsers,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refUsersTable,

    statusFilter,

    reFetchData,
  }
}
